import React from "react";
import IMAGES from "../../constants/images";

export default function Index() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-6">
      {/* Image */}
      <div className="mb-6 flex items-center justify-center">
        <img
          src={IMAGES.no_recent}
          alt="Empty Analytics"
          className="w-50 opacity-80"
        />
      </div>
      {/* Text */}
      <p className="text-center text-[#4B61FF] text-base font-medium font-poppins">
        You have no appointments yet.
      </p>
      <p className="text-center text-[#334155] text-sm font-normal font-poppins">
        Once patients start booking, they will appear here.
      </p>
    </div>
  );
}
